import type { MenuItem } from '../interfaces/header-response.interfaces';

export const getCategoryDetails = (subNavItem: MenuItem) => {
  const isBasicCategory = subNavItem.CategoryType === 'basic';
  const noOfCategoriesToShow = Number(
    !isBasicCategory && Number(subNavItem?.CategoryType?.slice(-1)),
  );

  // Take only the first N valid blocks based on CategoryType selection
  const blocksToRender = subNavItem?.Blocks?.slice(0, noOfCategoriesToShow);

  // Filter blocks to only include those with valid label AND at least one sublink
  const validBlocks = !isBasicCategory
    ? blocksToRender?.filter((block) => block.Label && block.SubNavigation?.length > 0) || []
    : [];
  return { isBasicCategory, blocksToRender, validBlocks };
};
